"use client";

import { DatePicker } from "@/components/ui/date-picker";

interface BirthDateFieldProps {
  /** Classes for the trigger, so a screen with its own field metrics can apply them. */
  className?: string;
  id?: string;
  value?: Date;
  onValueChange: (date: Date) => void;
  /** The typed text no longer names a date: the form's value empties with it. */
  onClear?: () => void;
  onBlur?: () => void;
  invalid?: boolean;
}

export function BirthDateField(props: BirthDateFieldProps) {
  return <DatePicker {...props} title="Data de nascimento" enableYearJump />;
}
